// @ts-nocheck
/**
Pattern

Holds a pattern of notes. The previous version had a fixed number of patterns
that could be placed into channels. This version of the feature remains here to
not interfere with any future development. We use patterns in the newer version
to create "stamps" to paint selections of notes onto the staff.

Status: Legacy
*/

import ../extensions.civet
Model from ../model.civet

export Pattern := (I={}, self=new Model(I)) ->
  defaults I,
    beats: 8
    notes: []

  I.beats = Number(I.beats) // Force number

  if isNaN(I.beats)
    throw new Error "Beats must be a number"

  self.attrObservable "beats"
  self.attrAccessor "notes"

  Object.assign self,
    addNote: (note) ->
      I.notes.push(note)

    removeNote: ([time, note]) ->
      matched := I.notes.filter ([t, n]) ->
        time is t and note is n

      self.notes().remove matched.last()

    size: ->
      self.beats()

    // `t` and `dt` are in beats.
    upcomingNotes: (t, dt) ->
      self.notes().filter ([time]) ->
        if dt > 0
          t <= time < t + dt
        else if dt < 0
          t + dt < time <= t
      .map ([time, note, instrument]) ->
        [time - t, note, instrument]

export default Pattern
